import axios from 'axios';
import { useCookies} from 'react-cookie';

interface pagination {
    page: number,
    page_size: number,
    keyword?: string,
    class_type_id?: number;
    class_type_category?: string;
    quarter?: string;
    year?: number;
    type?: string;
    limit?: 'yes' | 'no';
    filter_type?: string;
}

class ClientIrsApi {

    url: string;
    source = axios.CancelToken.source()

    constructor() {
    //    this.url = "http://127.0.0.1:8000"

       this.url = "https://mbi2025.zainrohn.com/api/public";  

// this.url = "https://idb.zainrohn.com/api/public";    

        //add line 

// this.url = "https://ifrs.zainrohn.com/public";   
 
    const [cookies, _, removeCookie] = useCookies();

        // Add Auth header
        axios.interceptors.request.use((config) => {

            config.headers["Accept"] = "application/json"
            config.headers["Content-Type"] = "application/json"
            config.headers["X-Requested-With"] = "XMLHttpRequest"
            config.cancelToken = this.source.token;
            if (cookies.userinfo) {
                config.headers["Authorization"] = cookies.userinfo.accessToken;
            }
            return (config);

        })

        // Handle 401
        axios.interceptors.response.use((response) => {
            if (!response)
                return Promise.reject(response)
            return response
        }, function (error) {
            if (!error)
                return Promise.reject(error);
            if (401 === error.response?.status) {
                removeCookie("userinfo")
                removeCookie("token")
            } else {
                return Promise.reject(error);
            }
        });
    }
    /**
     * Client IRS profile APIs
     * @param {}
     */
    irs_profile(): {
        index(query: pagination, id: number,year:number,quarter:string): any;
        store(query: { client_id: number; answers: number[] ,year:number,quarter:string}): any;
        
        store_Groupe(query: { client_id: string[]; answers: number[] ,year:number | undefined,quarter:string | undefined}): any;
        update_profile(query: { client_id: number; answers: number[] ,year:number,quarter:string}): any;
       // update_profile(query: { id: number }): any;


        delete(query: { id: number }): any;

    } 
    
    {
        var endpoints: any = {}

        endpoints.index = (query: any, id: number,year:number,quarter:string,name = 'irs/client-profile/all') => axios.get(`${this.url}/${name}/${id}/${year}/${quarter}`, { params: query })

        endpoints.store = (query: any, name = 'irs/client-profile') => axios.post(`${this.url}/${name}`, query)

        endpoints.store_Groupe = (query: any, name = 'irs/client-profile/group') => axios.post(`${this.url}/${name}`, query)

        endpoints.update_profile = (query: any, name = 'irs/update_profile') => axios.post(`${this.url}/${name}`, query)

        //endpoints.update_profile = (query: any, name = "irs/delete") => axios.delete(`${this.url}/${name}/${query.id}`, { params: query })

        endpoints.delete = (query: any, name = "irs/delete") => axios.delete(`${this.url}/${name}/${query.id}`, { params: query })

        return endpoints
    }
    abortCalls = () => this.source.cancel('Operation canceled due to route change.')
}

export default ClientIrsApi